import { useState } from "react";
import ProjectGrid from "./ProjectGrid";
import { projects } from "../../data/portfollio";

const services = [
  { id: "model", label: "Модели Базис мебельщик" },
  { id: "client", label: "Чертежи для согласования" },
  { id: "pasport", label: "Паспорта для сборки" },
];

export default function ServicesSection() {
  const [active, setActive] = useState("model");

  const filteredProjects = active
    ? projects.filter((p) => p.category === active)
    : [];

  return (
    <section className="mb-24">
      <div className="mb-8 rounded-3xl border border-slate-200 bg-white/90 p-6 sm:p-8 shadow-[0_10px_26px_rgba(15,23,42,0.08)]">
        <h2 className="text-3xl sm:text-4xl font-semibold text-slate-900 tracking-tight">
          Документация к реальным проектам
        </h2>
        <p className="mt-3 text-slate-600 max-w-3xl">
          Выберите раздел и посмотрите реальные проекты: модели в БАЗИС, чертежи для согласования и паспорта для сборки.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {services.map((s) => (
          <button
            key={s.id}
            onClick={() => setActive(s.id)}
            className={`
              p-5 rounded-2xl border text-left transition-all duration-200
              ${
                active === s.id
                  ? "border-slate-900 bg-slate-900 text-white shadow-[0_10px_20px_rgba(15,23,42,0.22)] -translate-y-0.5"
                  : "border-slate-200 bg-white text-slate-900 hover:border-slate-300 hover:-translate-y-0.5"
              }
            `}
          >
            <h3 className="text-lg font-semibold mb-1">
              {s.label}
            </h3>
            <p className={`text-sm ${active === s.id ? "text-slate-200" : "text-slate-500"}`}>
              Нажмите, чтобы посмотреть примеры работ
            </p>
          </button>
        ))}
      </div>

      {active && (
        <div className="mt-10">
          <ProjectGrid projects={filteredProjects} />
        </div>
      )}
    </section>
  );
}
